import { render, staticRenderFns } from "./PointBankAnotherlaneError.vue?vue&type=template&id=f57ff3e2"
import script from "./PointBankAnotherlaneError.vue?vue&type=script&lang=js"
export * from "./PointBankAnotherlaneError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports